export default {
    hero: {
        title: "Eve Mind",
        claim: "The revolutionary Trade Copilot",
        description: "One platform to ship, control, insure, and pay – powered by AI",
        ctaLogin: "Log in",
        ctaContact: "Contact us",
    },
    cta: {
        headline: "GLOBAL TRADE: A $30T INDUSTRY STILL RUNNING ON EMAILS AND EXCELS.",
        subline: "This is going to change",
    },
    agents: {
        care: {
            title: "Eve Care",
            subtitle: "AI Customer Care Agent",
            description: "A context-aware AI agent for customer care, trained on your account information. Understands requests, responds in real-time, updates customers on shipment status, calls external carriers, and automatically records all interactions in the system. Can also negotiate rates, recognizing available margins to optimize every shipment.",
            features: [
                "Responds to customer requests in real-time",
                "Automatically updates customers on shipment status",
                "Negotiates rates and optimizes margins",
                "Records all interactions automatically",
            ],
        },
        track: {
            title: "Eve Track",
            subtitle: "Real-Time Tracking Agent",
            description: "An AI agent that connects satellite data, carrier communications, and management systems in real-time. Automatically responds to customers asking for updates, consults GPS data or calls the carrier or driver to get their location. Eve Track collects, verifies, and updates the status of every shipment, creating complete visibility and generating automatic notifications in case of delays or anomalies. Customer care no longer needs to 'search for information': they receive it ready, reliable, and in real-time.",
            features: [
                "Connects satellite data and GPS in real-time",
                "Automatically responds to customer update requests",
                "Generates notifications for delays and anomalies",
                "Provides complete shipment visibility",
            ],
        },
        quote: {
            title: "Eve Quote",
            subtitle: "Quotation Automation Agent",
            description: "The AI agent that automates and manages the entire quotation lifecycle, from receiving the request to follow-up with the customer. Eve Quote automatically reads and interprets incoming requests, extracts key data, and calculates the most suitable rate in seconds using your price lists and pricing rules. Generates a professional offer, ready to be sent, and continues to follow the conversation: answers questions, handles modifications or updates to the quotation, and maintains a history of all interactions. Automatically archives and indexes every quote, making it simple to find previous offers in one click without having to dig through emails or conversation threads.",
            features: [
                "Calculates rates in seconds using your pricing rules",
                "Generates professional offers ready to send",
                "Handles modifications and updates automatically",
                "Archives and indexes every quote for easy retrieval",
            ],
        },
        read: {
            title: "Eve Read",
            subtitle: "Document Reading Agent",
            description: "Reads and interprets every document automatically, regardless of format. Extracts key data, structures it, and sends it directly to the TMS, immediately flagging any anomalies. Eve Read doesn't just read: it learns how you want your data organized, and does it better and better.",
            features: [
                "Reads documents in any format automatically",
                "Extracts and structures key data instantly",
                "Sends data directly to your TMS",
                "Learns your data organization preferences",
            ],
        },
        plan: {
            title: "Eve Plan",
            subtitle: "Route Planning Agent",
            description: "Analyzes order flows, vehicle availability, and operational restrictions, suggesting the most efficient travel plan for each day. When conditions change - a delay, a new order, or a breakdown - the system recalculates priorities in real-time, proposing the optimal solution to the logistics manager for approval or modification.",
            features: [
                "Suggests the most efficient travel plans daily",
                "Recalculates priorities in real-time when conditions change",
                "Considers vehicle availability and operational restrictions",
                "Proposes optimal solutions for manager approval",
            ],
        },
    },
    features: {
        label: "Features",
        title: "Powerful AI agents to transform your trade operations",
        description: "Five intelligent agents working together to automate, optimize, and revolutionize your logistics workflow. Trusted by forward-thinking companies worldwide.",
    },
    footer: {
        contactTitle: "Ready to transform your logistics?",
        contactDescription: "Get in touch with our team to learn more about Eve Mind.",
        contactButton: "Contact us",
        loginLink: "Already have an account?",
        loginButton: "Log in",
    },
};

